var map = {
	"./01-atoms/accordion": 5765,
	"./01-atoms/accordion-pane": 1796,
	"./01-atoms/alert": 9464,
	"./01-atoms/authors": 693,
	"./01-atoms/bg-overlay": 959,
	"./01-atoms/block-title": 4549,
	"./01-atoms/breadcrumb": 4227,
	"./01-atoms/burger": 939,
	"./01-atoms/button": 8895,
	"./01-atoms/caption": 9289,
	"./01-atoms/certification": 5878,
	"./01-atoms/comma-separated-link-list": 8486,
	"./01-atoms/content-table": 4646,
	"./01-atoms/country-map-svg": 149,
	"./01-atoms/date": 1433,
	"./01-atoms/field-fact-and-figure": 9894,
	"./01-atoms/file-link": 5097,
	"./01-atoms/footer-strapline": 538,
	"./01-atoms/form-element-checkbox": 3677,
	"./01-atoms/form-element-label": 1598,
	"./01-atoms/form-element-select": 413,
	"./01-atoms/form-element-submit": 4312,
	"./01-atoms/form-element-textarea": 1302,
	"./01-atoms/form-element-textfield": 2086,
	"./01-atoms/form-input": 1385,
	"./01-atoms/icon-divider": 4156,
	"./01-atoms/icon-email": 8506,
	"./01-atoms/icon-facebook": 6603,
	"./01-atoms/icon-file": 8753,
	"./01-atoms/icon-home": 2735,
	"./01-atoms/icon-instagram": 3646,
	"./01-atoms/icon-linkedin": 5331,
	"./01-atoms/icon-twitter": 1315,
	"./01-atoms/icon-youtube": 4303,
	"./01-atoms/image": 5145,
	"./01-atoms/jump-menu": 6994,
	"./01-atoms/link-list-item": 1816,
	"./01-atoms/logo": 9695,
	"./01-atoms/more-button": 2392,
	"./01-atoms/page-title": 5740,
	"./01-atoms/pagewrapper": 6471,
	"./01-atoms/primary-menu-link": 398,
	"./01-atoms/primary-submenu-link": 406,
	"./01-atoms/published-date": 3094,
	"./01-atoms/quote": 8430,
	"./01-atoms/search-icon": 9513,
	"./01-atoms/secondary-menu-link": 4391,
	"./01-atoms/small-print-link": 7241,
	"./01-atoms/strapline": 1667,
	"./01-atoms/subtitle": 3440,
	"./01-atoms/timeline-item-title": 6063,
	"./01-atoms/unpublished-banner": 2801,
	"./01-atoms/video": 7435,
	"./01-atoms/view-style-list-item": 3244,
	"./02-molecules/branding": 4334,
	"./02-molecules/breadcrumb": 9093,
	"./02-molecules/content-section-accordion": 5944,
	"./02-molecules/content-section-call-to-action": 8155,
	"./02-molecules/content-section-embed": 2313,
	"./02-molecules/content-section-image": 7346,
	"./02-molecules/content-section-image-gallery": 2729,
	"./02-molecules/content-section-image-text": 7944,
	"./02-molecules/content-section-link-block": 7813,
	"./02-molecules/content-section-quote": 4686,
	"./02-molecules/content-section-text": 163,
	"./02-molecules/content-section-video": 5267,
	"./02-molecules/content-section-view-block": 7511,
	"./02-molecules/cookie-compliance": 7514,
	"./02-molecules/country-picker": 3067,
	"./02-molecules/doormat-navigation": 5194,
	"./02-molecules/doughnut-chart": 2022,
	"./02-molecules/downloads": 6743,
	"./02-molecules/exposed-filter-search": 6767,
	"./02-molecules/facets": 5677,
	"./02-molecules/form": 6570,
	"./02-molecules/header-quick-links": 1903,
	"./02-molecules/header-search": 8329,
	"./02-molecules/hero-image": 8793,
	"./02-molecules/language-switcher": 2356,
	"./02-molecules/link-block-button": 6681,
	"./02-molecules/local-tasks": 5847,
	"./02-molecules/mobile-quick-links": 1580,
	"./02-molecules/near-you": 7197,
	"./02-molecules/newsletter_form": 7568,
	"./02-molecules/node-footer": 8553,
	"./02-molecules/node-teaser-brief": 8609,
	"./02-molecules/node-teaser-grid": 8454,
	"./02-molecules/node-teaser-list": 2717,
	"./02-molecules/post-details": 8385,
	"./02-molecules/primary-menu": 5198,
	"./02-molecules/related-to": 9480,
	"./02-molecules/search-result": 5089,
	"./02-molecules/separate-content-block": 5573,
	"./02-molecules/small-print-links": 6255,
	"./02-molecules/social_follow_links": 6420,
	"./02-molecules/social_share_links": 9665,
	"./02-molecules/stripe-footer": 1971,
	"./02-molecules/sub-navigation": 4823,
	"./02-molecules/tags": 3714,
	"./02-molecules/timeline-date": 1195,
	"./02-molecules/timeline-item": 7539,
	"./02-molecules/utility-menu": 9215,
	"./02-molecules/view-style-grid": 5236,
	"./02-molecules/view-style-list": 9492,
	"./03-organisms/block-in-paragraph": 5231,
	"./03-organisms/content-item-list": 1532,
	"./03-organisms/ct-blog": 1710,
	"./03-organisms/ct-campaign": 9796,
	"./03-organisms/ct-content-item": 7875,
	"./03-organisms/ct-content-item--short-listing": 7472,
	"./03-organisms/ct-country": 5290,
	"./03-organisms/ct-emergency": 8509,
	"./03-organisms/ct-issue": 999,
	"./03-organisms/ct-landing-page": 5645,
	"./03-organisms/ct-leaderboard": 8377,
	"./03-organisms/ct-letters-and-statements": 2138,
	"./03-organisms/ct-policy-paper": 5984,
	"./03-organisms/ct-press-release": 8883,
	"./03-organisms/facets-item-list": 193,
	"./03-organisms/footer": 7251,
	"./03-organisms/form-emergency-donation": 6254,
	"./03-organisms/link-to-affiliate-block": 3264,
	"./03-organisms/masthead": 1526,
	"./03-organisms/modal-dialog": 5851,
	"./03-organisms/modal-seasonal": 1748,
	"./03-organisms/paragraph-call-to-action": 6806,
	"./03-organisms/related-content-block": 7289,
	"./03-organisms/related-items-block": 8210,
	"./04-templates/frontpage": 1087,
	"./04-templates/node": 386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3497;